import { MetricDetails } from '../../../../api/metrics/types';
import { SQLFilters } from '../../../../api/types';
import { MetricId } from '../../../../api/types-graphql';
import { MetricIdType, OverTimeTimeSelection } from '../../../../types';
import { LanguageString } from '../../dashboards/types';
import { TitleConfig } from '../../ui-components/data-viz-ui/charts/common/common-chart-types';
import {
  BenchmarkPeriods,
  ExternalChartComponentProps,
  OvertimeVizDatapoint,
} from '../common/types';

export type OverTimeUnsegmentedVizExternalProps = ExternalChartComponentProps;

export interface OverTimeVizQuery {
  metric: MetricIdType;
  filters?: SQLFilters;
}

type OverTimeUnsegmentedBenchmarkConfig = {
  benchmarkPeriod: BenchmarkPeriods;
};
export interface OverTimeUnsegmentedVizConfig {
  title?: LanguageString;
  subtitle?: LanguageString;
  timeSelection: OverTimeTimeSelection;
  queries: OverTimeVizQuery[];
  benchmarkConfig?: OverTimeUnsegmentedBenchmarkConfig;
  chartColors?: string[];
}

export type OverTimeUnsegmentedVizDataResponseForMetricForDate<
  HasBenchmark extends boolean,
> = {
  dateLabel: string;
  datapoint: OvertimeVizDatapoint<HasBenchmark>;
};

export type OverTimeUnsegmentedVizDataResponseForMetric<
  HasBenchmark extends boolean,
> = {
  metric: MetricIdType;
  metricSql: string | null;
  data: OverTimeUnsegmentedVizDataResponseForMetricForDate<HasBenchmark>[];
};

export type OverTimeUnsegmentedVizDataResponseForMetricWithoutBenchmark = {
  metric: MetricIdType;
  metricSql: string | null;
  data: {
    dateLabel: string;
    datapoint: {
      value: number;
    };
  }[];
};

export type OverTimeUnsegmentedVizDataResponse<
  HasBenchmark extends boolean = any,
> = {
  responseForMetrics: OverTimeUnsegmentedVizDataResponseForMetric<HasBenchmark>[];
};

export type OverTimeUnsegmentedVizData = {
  titleConfig: TitleConfig;
  metricDisplayValues: Partial<Record<MetricId, string>>;
  metricDetailsMap: Partial<Record<MetricId, MetricDetails>>;
  chartColors?: string[];
  dataResponse: OverTimeUnsegmentedVizDataResponse;
};

export enum OverTimeUnsegmentedVizViews {
  LINE_CHART = 'line-chart',
  BAR_CHART = 'bar-chart',
  TABLE_VIEW = 'table-view',
}
